/**
 * متى نطلب إذن «المنبّهات والتذكيرات»؟
 *
 * بلا هذا الإذن يتأخّر الأذان دقائق، ويمنع النظام مشغّله فلا يُسمع إلا
 * إشعاراً. فنطلبه — لكن بلا إلحاح: من أجّل الطلب لا نعيده قبل أسبوع.
 */

export const EXACT_PROMPT_KEY = 'moslam_exact_prompt_dismissed';
export const EXACT_PROMPT_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * القرار وحده، بلا منصّة ولا تخزين، ليُختبر.
 * exactAllowed غير معروف بعد (undefined) ⇒ لا نُظهر شيئاً حتى نتيقّن.
 */
export function shouldShowExactPrompt({ exactAllowed, dismissedAt, now }) {
  if (exactAllowed !== false) return false;
  // قيمة تالفة، أو من المستقبل (ساعة الجهاز عُدّلت): لا تحجب الطلب إلى الأبد
  if (!Number.isFinite(dismissedAt) || dismissedAt > now) return true;
  return now - dismissedAt >= EXACT_PROMPT_COOLDOWN_MS;
}

/** وقت آخر تأجيل، أو null. التخزين قد يُمنع (وضع خاص) فلا يُسقط الصفحة. */
export function readExactPromptDismissedAt() {
  try {
    const raw = localStorage.getItem(EXACT_PROMPT_KEY);
    return raw ? Number(raw) : null;
  } catch {
    return null;
  }
}

export function markExactPromptDismissed(now = Date.now()) {
  try {
    localStorage.setItem(EXACT_PROMPT_KEY, String(now));
  } catch {
    // بلا تخزين يعود الطلب في الإقلاع القادم، ولا ضرر
  }
}
